/*
 * BHC — colorway switching on product cards.
 *
 * Cards render a `.bhc-card-colors` overlay carrying a JSON list of colorways
 * (see snippets/bhc-color-dots.liquid). Clicking an arrow or a dot swaps the
 * card's image to that colorway's front photo and repoints the card link at
 * that variant.
 *
 * The card's real link (a.product-card__link) is a SIBLING overlay, not an
 * ancestor of the dots, so the link is found by walking up to the card element
 * and updating every product link inside it. Cards are also initialised on load
 * so the link carries ?variant= for the colorway shown before any click —
 * otherwise the PDP falls back to the first *available* variant, which can be a
 * different color than the card is showing.
 *
 * Listeners are delegated off the document so cards injected later — the
 * JS-rendered "You May Also Like" grid — work without re-binding.
 */
(function () {
  if (window.__bhcCardColors) return;
  window.__bhcCardColors = true;

  var CARD_SELECTOR = 'product-card, .product-card, .card-wrapper, .resource-card, li';

  function readColors(root) {
    try {
      return JSON.parse(root.getAttribute('data-bhc-colors') || '[]');
    } catch (e) {
      return [];
    }
  }

  function cardRoot(root) {
    return root.closest(CARD_SELECTOR) || root.parentElement;
  }

  function cardImage(root) {
    var wrap = root.parentElement;
    var img = wrap ? wrap.querySelector('img') : null;
    if (img) return img;
    var card = cardRoot(root);
    return card ? card.querySelector('img') : null;
  }

  function setLinks(root, variantId) {
    if (!variantId) return;
    var card = cardRoot(root);
    if (!card) return;
    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var base = (links[i].getAttribute('href') || '').split('?')[0];
      if (!base) continue;
      links[i].setAttribute('href', base + '?variant=' + variantId);
    }
  }

  function apply(root, index, skipImage) {
    var colors = readColors(root);
    if (!colors.length) return;

    var i = ((index % colors.length) + colors.length) % colors.length;
    root.setAttribute('data-bhc-index', String(i));

    if (!skipImage) {
      var img = cardImage(root);
      if (img && colors[i].i) {
        img.removeAttribute('srcset');
        img.src = colors[i].i;
        if (colors[i].a) img.alt = colors[i].a;
      }
    }

    var dots = root.querySelectorAll('.bhc-swatch');
    for (var d = 0; d < dots.length; d++) {
      var di = parseInt(dots[d].getAttribute('data-i'), 10);
      if (di === i) dots[d].classList.add('is-active');
      else dots[d].classList.remove('is-active');
    }

    setLinks(root, colors[i].v);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.bhc-card-colors:not([data-bhc-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-bhc-ready', '1');
      apply(roots[i], parseInt(roots[i].getAttribute('data-bhc-index') || '0', 10) || 0, true);
    }
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var hit = target.closest('.bhc-card-colors__arrow, .bhc-swatch');
    if (!hit) return;

    var root = hit.closest('.bhc-card-colors');
    if (!root) return;

    // These controls sit over the card link — stop it navigating.
    e.preventDefault();
    e.stopPropagation();

    if (hit.classList.contains('bhc-swatch')) {
      apply(root, parseInt(hit.getAttribute('data-i'), 10) || 0);
      return;
    }

    var current = parseInt(root.getAttribute('data-bhc-index') || '0', 10) || 0;
    var step = hit.classList.contains('bhc-card-colors__arrow--next') ? 1 : -1;
    apply(root, current + step);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // The "You May Also Like" grid is injected after load, so a document-wide
  // observer is genuinely needed here — but it must not run a full-document
  // query on every mutation. Coalesce bursts into one pass per frame.
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        init();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
